import { ImageWithTextSection } from '@quicktools/shared-components';
import IImageWithTextSection from '@quicktools/shared-components/components/landingPages/ImageWithTextSection/types';
import { Trans, useTranslation } from 'react-i18next';

function ImageSections() {
  const { t } = useTranslation();

  // const texts = t('landing.imageSection', { returnObjects: true }) as IImageWithTextSection[];

  let imageSectionItems: IImageWithTextSection[] = [
    {
      title: t('landing.imageSection.0.title'),
      description: t('landing.imageSection.0.description'),
      imageWidth: 435,
      imgSrc: 'images/image-section-1.png',
      imgAlt: 'changeIt',
    },
    {
      title: t('landing.imageSection.1.title'),
      imageWidth: 435,
      imgSrc: 'images/image-section-2.png',
      imgAlt: 'changeIt',
      imageRight: true,
      children: (
        <div>
          {t('landing.imageSection.1.children.paragraph')}

          <ul style={{ marginTop: 24, marginLeft: 30 }}>
            <li>
              <Trans i18nKey={'landing.imageSection.1.children.list.0'} components={{ a: <a /> }} />
            </li>
            <li>{t('landing.imageSection.1.children.list.1')}</li>
            <li>
              <Trans i18nKey={'landing.imageSection.1.children.list.2'} components={{ a: <a /> }} />
            </li>
            <li>{t('landing.imageSection.1.children.list.3')}</li>
          </ul>
        </div>
      ),
    },
    {
      title: t('landing.imageSection.2.title'),
      description: t('landing.imageSection.2.description'),
      imageWidth: 435,
      imgSrc: 'images/image-section-3.png',
      imgAlt: 'changeIt',
    },
  ];

  imageSectionItems = imageSectionItems.map((section, i) => ({
    ...section,
    ...imageSectionItems[i],
  }));

  return (
    <>
      {imageSectionItems.map(({ ...sectionProps }, i) => (
        <ImageWithTextSection key={i} {...sectionProps} />
      ))}
    </>
  );
}

export default ImageSections;
